// extracted by mini-css-extract-plugin
export const editorsChoice = "editorschoice-module--editorsChoice--3ipi_";
export const background = "editorschoice-module--background--VXiCo";
export const crow = "editorschoice-module--crow--3yk2Y";
export const ring = "editorschoice-module--ring--2_Exj";